//@actions
const {BizumDataReset} = require('actions/contactCenter/authorizeBizum');

// @helpers
const actionTypes = require('constants/contactCenter/actionTypes');
const { portabilityBizumRequest} = require('utilities/contactCenter/bizumActionsHelper');

//constants
const { ERROR_INVALID_PORTABILITY_CODE, ERROR_REGISTER_BIZUM_SUCCESSFUL } = require('constants/contactCenter/errorTypes');

const simpleActionCreator = (type) => (payload) => ({ type, payload });

const reset = simpleActionCreator(actionTypes.BIZUM_CONFIRMATION_RESET);
const setCode = simpleActionCreator(actionTypes.BIZUM_CONFIRMATION_SET_CODE);
const setScreen = simpleActionCreator(actionTypes.BIZUM_CONFIRMATION_SET_SCREEN);
const showModal = simpleActionCreator(actionTypes.BIZUM_CONFIRMATION_SHOW_MODAL);

const resend = () => (dispatch) => {
    dispatch(reset())
    dispatch(BizumDataReset());
};

const validate = () => (dispatch, getState) => {
    const validateRequest = simpleActionCreator(actionTypes.BIZUM_CONFIRMATION_VALIDATE_REQUEST);
    const validateFailure = simpleActionCreator(actionTypes.BIZUM_CONFIRMATION_VALIDATE_FAILURE);
    const validateError = simpleActionCreator(actionTypes.BIZUM_CONFIRMATION_VALIDATE_ERROR);
    const validateSuccess = simpleActionCreator(actionTypes.BIZUM_CONFIRMATION_VALIDATE_SUCCESS);

    dispatch(validateRequest());
    return portabilityBizumRequest(dispatch, getState)
        .then(response => {
            if (response.error === ERROR_REGISTER_BIZUM_SUCCESSFUL) {
                dispatch(validateSuccess(response));
            } else if (response.error === ERROR_INVALID_PORTABILITY_CODE) { // if portability code is invalid
                dispatch(validateFailure(response.error));
            } else {
                dispatch(validateError(response.error));
            }
        })
        .catch(response => {
            if (!!response.error) { // if API fails and has error
                dispatch(validateError(response.error));
            } else {
                throw response;
            }
        });
};


module.exports = {
    reset,
    resend,
    validate,
    setCode,
    setScreen,
    showModal
};
